export default "__VITE_ASSET__DWFdFFjk__";